<template>
  <div class="block-head">
    <bimContainer>
      <bimCol cols=12 md=10 class="mx-auto">
        <bim-text adaptive class="block-head__title text-center" type="h1" bold>{{ $t("Мастер спецификаций BIMLIB") }}</bim-text>
        <bim-text adaptive class="block-head__text text-center mt-6" type="h5" bold>{{ $t("Программа для проектировщиков") }}</bim-text>
        <ButtonPluginDownload class="text-center my-11" />
        <bim-text adaptive type=accent class="text-center mb-10" bold>Инженерам</bim-text>

        <div class="d-flex flex-wrap advantages mb-4">
          <bim-col cols=6 xl=3 class="d-flex flex-column">
            <div class="mb-9 advantages__wrapper">
              <div class="advantages-arrow__wrapper">
                <img alt="" class="advantages-arrow--reverse advantages-arrow" src="/dist/assets/front_white/img/landing_plugin/arrow-left.svg" />
              </div>
              <bim-text type=main adaptive bold class="mb-1">Заказчик:</bim-text>
              Получает несколько вариантов спецификаций и возможность следить за проектом онлайн
            </div>
            <div class="advantages__wrapper">
              <div class="advantages-arrow__wrapper">
                <img alt="" class="advantages-arrow--reverse advantages-arrow" src="/dist/assets/front_white/img/landing_plugin/arrow-left.svg" />
              </div>
              <bim-text type=main adaptive bold class="mb-1">Подрядчик:</bim-text>
              Выбирает комфортное решения для монтажа
            </div>
          </bim-col>
          <bim-col cols=12 xl=6 class="advantages__image-wrapper mt-9 mt-xl-0">
            <img alt="" class="advantages__image" src="/dist/assets/front_white/img/landing_plugin/special-m-slanding.jpg" />
          </bim-col>
          <bim-col cols=6 xl=3 class="d-flex flex-column">
            <div class="mb-9 advantages__wrapper">
              <div class="advantages-arrow__wrapper">
                <img alt="" class="advantages-arrow" src="/dist/assets/front_white/img/landing_plugin/arrow-left.svg" />
              </div>
              <bim-text type=main adaptive bold class="mb-1">Инженеры:</bim-text>
              Получают удобный поиск и формирование документации
            </div>
            <div class="advantages__wrapper">
              <div class="advantages-arrow__wrapper">
                <img alt="" class="advantages-arrow" src="/dist/assets/front_white/img/landing_plugin/arrow-left.svg" />
              </div>
              <bim-text type=main adaptive bold class="mb-1">Производители:</bim-text>
              Знают, какую продукцию закладывают в проект
            </div>
          </bim-col>
        </div>

        <bim-text adaptive type=main class="text-center mt-11 mb-3">В Мастере спецификаций уже доступно более</bim-text>
        <bim-text adaptive type=h5 class="text-center">2 000 000 позиций!</bim-text>

        <bim-text adaptive type=accent class="mb-10 mt-11 text-center" bold>{{ $t("В системе представлена продукция:") }}</bim-text>

        <div class="manufacturer__wrapper d-flex">
          <a
            v-for="man of manufacturers"
            :key="man.id"
            :href="formLinkMan(man)"
            target="_blank"
            class="manufacturer__item d-flex justify-center align-center"
          >
            <img alt="" :src="man.logo.link" class="manufacturer__logo" />
          </a>
        </div>
        <manufacturers_count class="mt-11 mb-11 text-center d-block mx-auto" from=plugin />
        <ButtonPluginDownload class="text-center" />
      </bimCol>
    </bimContainer>
  </div>
</template>

<script>
import bimContainer from "@bimlib/components/bimContainer"
import bimCol from "@bimlib/components/bimCol"
import ButtonPluginDownload from "./ButtonPluginDownload"
export default {
  name: "",
  components: {
    bimContainer,
    bimCol,
    ButtonPluginDownload,
  },
  data() {
    return {
      manufacturers: []
    }
  },
  created() {
    this.getManufacturers()
  },
  methods: {
    getManufacturers() {
      axios
        .get('/?m=news&a=getMainPageOrgs&limit=24')
        .then(res => res.data)
        .then(res => this.manufacturers = res)
    },
    formLinkMan(man) {
      return `/manufacturer/${man.name_alias}/${man.id}`
    },
  },
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";

.text-center {
  text-align: center;
}

.block-head {
  padding: 64px 0 121px;
  background-color: $white-color;

  @media screen and (max-width: $breakpoint-sm) {
    padding: 0 0 45px;
  }

  .block-head__image {
    width: 100%;
  }

  .block-head__title {

    ::v-deep .text__inner {
      font-size: 42px;
      line-height: 1.08;

      @media screen and (max-width: $breakpoint-sm) {
        font-size: 32px;
      }
    }
  }

  .block-head__text {
    line-height: 1.22;
  }
}

.manufacturer__wrapper {
  flex-wrap: wrap;
  justify-content: center;

  .manufacturer__item {
    margin-right: 33px;
    margin-bottom: 42px;
    flex: 0 0 9.45%;

    @media screen and (min-width: $breakpoint-xl) {
      &:nth-child(8n) {
        margin-right: 0;
      }
    }

    @media screen and (min-width: $breakpoint-lg) and (max-width: $breakpoint-xl) {
      flex: 0 0 10.37%;
      &:nth-child(7n) {
        margin-right: 0;
      }
    }

    @media screen and (min-width: $breakpoint-md) and (max-width: $breakpoint-lg) {
      flex: 0 0 15.3%;
      &:nth-child(5n) {
        margin-right: 0;
      }
    }
    @media screen and (min-width: $breakpoint-sm) and (max-width: $breakpoint-md) {
      flex: 0 0 20.1%;
      &:nth-child(4n) {
        margin-right: 0;
      }
    }
    @media screen and (min-width: $breakpoint-xs) and (max-width: $breakpoint-sm) {
      flex: 0 0 16%;
      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }

  .manufacturer__logo {
    object-fit: contain;
  }
}

.advantages {
  .advantages__wrapper {
    line-height: 1.57;
    letter-spacing: 0.2px;
    font-size: 14px;

    @media screen and (max-width: $breakpoint-sm) {
      font-size: 12px;
    }
  }
  .advantages-arrow--reverse {
    transform: rotate(180deg)
  }
  .advantages-arrow__wrapper {
    margin-bottom: 8px;

    @media screen and (max-width: $breakpoint-xl) {
      display: none;
    }
  }
  .advantages__image-wrapper {
    @media screen and (max-width: $breakpoint-xl) {
      order: 1;
    }
  }
  .advantages__image {
    box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.1);
  }
}
</style>
